const formatPrice = (price) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "Gbp",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);
};

export default formatPrice;
